module.exports = __webpack_public_path__ + "img/desktop_mac.04b19e0e.svg";